import { _baseClient } from '../index';

export const activityList = (pageSize, pageNumber, query = {}) => {
  return _baseClient.post('/activity/list', {
    body: {
      pageSize: pageSize,
      pageNumber: pageNumber,
      ...query,
    },
  });
};
export const activityGet = (params) => {
  return _baseClient.get('/activity/get', params);
};

export const activityExport = (params) => {
  return _baseClient.post('/activity/export', { body: params }).then((response) => {
    return response;
  });
};
